import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'menu-section',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './menu-section.component.html',
})
export class MenuSectionComponent implements OnInit {
    @Input() items: any[] = [];
    @Input() type!: string;
    @Input() label!: string;
    @Input() pinnedDashboards: any[] = [];
    @Input() defaultOpen = false;
    @Output() togglePin = new EventEmitter<any>();

    open = false;

    ngOnInit(): void {
        this.open = this.defaultOpen;
    }

    toggle(): void {
        this.open = !this.open;
    }

    get filteredItems() {
        return this.items.filter(c => c.type === this.type);
    }

    get iconClass() {
        return this.type === 'Dashboards' ? 'flaticon-graphic-2' : 'flaticon-line-graph';
    }
}
